module.exports = __webpack_public_path__ + "images/emoji/rugby_football.77103696ce0918ccb09a.png";